"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarbonNanosystems = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const Size_1 = require("../render/Size");
class CarbonNanosystems extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.CARBON_NANOSYSTEMS,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 14,
            resourceType: ResourceType_1.ResourceType.GRAPHENE,
            metadata: {
                cardNumber: 'X52',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect(undefined, (eb) => {
                        eb.science(1).played.startEffect.graphene(1);
                    });
                    b.br.br;
                    b.effect('When you play a Science tag, including this, add a graphene resource here. When playing a Space or City tag, graphenes may be used as 4 M€ each.', (eb) => {
                        eb.space().played.slash().cityTag().played.startEffect.graphene(1).nbsp(Size_1.Size.TINY).equals().megacredits(4);
                    });
                }),
                victoryPoints: 1,
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    onCardPlayed(player, card) {
        if (!player.cardIsInEffect(this.name))
            return;
        const qty = card.tags.filter((tag) => tag === Tags_1.Tags.SCIENCE).length;
        player.addResourceTo(this, { qty: qty, log: true });
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.CarbonNanosystems = CarbonNanosystems;
//# sourceMappingURL=CarbonNanosystems.js.map